import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { SessionService } from '../../services/session.service';
import { AuthenticationType } from '../../services/oidc.factory';
import { CognitoService } from '../../services/cognito.service';
import { PlatformApiService } from '../../services/platform-api.service';
import { ThemeManagerService } from 'src/app/services/theme-manager.service';
import { OidcConnectWiseService } from 'src/app/services/oidc.service';
import { LoggerService } from 'src/app/services/logger.service';
import { CognitoUser } from 'amazon-cognito-identity-js';

@Component({
  selector: 'app-login-verifymfa',
  template: `
  <form [formGroup]="mfaForm" class="dashboard-tile mat-elevation-z4">
    <div class="tile-header">
      <div class="tile-header-title">
        Multi-Factor Authentication
      </div>
    </div>
    <div class="tile-content">
      <img mat-card-image class="tile-logo" src="{{_themeManager.getStackedLogo()}}" >
      <div *ngIf="mfaSetup" style="display: flex; flex-direction: column;">
        <h3 class="text-primary">MFA is required to access the Identify application</h3>
        <h3 class="text-primary">Scan this barcode with your authenticator app</h3>
        <div style="align-self:center;" class="qr-container mat-elevation-z1"><qr-code [value]="mfaQrUri" [size]="150"></qr-code></div>
        <div style="padding-top: 20px;">If you can't use a barcode, you can enter this code instead:</div>
        <div style="padding-bottom: 20px; align-self:center" class="text-accent">{{mfaSecret}}</div>
      </div>

      <h3 class="text-primary">Enter the code from your authenticator app</h3>
      <div class="formFieldList">
        <mat-form-field>
          <mat-label>6 digit code (no spaces)</mat-label>
          <input matInput placeholder="e.x. 123456" formControlName="totpCode" required>
          <mat-error *ngIf="mfaForm?.controls?.totpCode.hasError('invalidTotp')">The authenticator code could not be verified</mat-error>
        </mat-form-field>
      </div>
      <div class="tile-footer centered">
      <button mat-button type="button" color="primary" (click)="stateChange.emit({state:'LOGIN'})">Cancel</button>
        <button mat-raised-button color="primary" type="submit" (click)="onLogin()">Login</button>
      </div>
    </div>
  </form>
  `,
  styleUrls: ['./auth.layout.scss']
})
export class VerifyMfaComponent implements OnInit {
  @Output() stateChange: EventEmitter<any> = new EventEmitter();
  mfaSecret: string;
  mfaQrUri: string;
  @Input() mfaSetup:boolean
  @Input() set totpSecretCode(secret:string) {
    const encoded = `${encodeURIComponent('ConnectWise Identify')}:${encodeURIComponent('email')}?secret=${secret}&issuer=${encodeURIComponent('ConnectWise Identify')}`;
    this.mfaSecret = secret;
    this.mfaQrUri = `otpauth://totp/${encoded}`;
  }

  @Input() cognitoUser: CognitoUser;

  mfaForm = new FormGroup ({
    totpCode: new FormControl('', [Validators.required]),
  });

  constructor(private _logger: LoggerService, public _themeManager: ThemeManagerService, private _cognitoService: CognitoService, private _oidcCwService: OidcConnectWiseService, private _platformApi: PlatformApiService, private _sessionService: SessionService, private _router: Router) { }

  ngOnInit() {
  }

  onLogin() {
    this._cognitoService.sendMfaToken(this.cognitoUser, this.mfaForm.controls.totpCode.value, this.mfaSetup).then(resp => {
      if (resp == 'SUCCESS') {
        this._sessionService.setAuthenticationType(AuthenticationType.COGNITO);
        this._platformApi.getCredentials().subscribe(
          creds => {
            this._sessionService.setApiCredentials(creds);
            this.stateChange.emit({state:'LOGINSUCCESS'})
          }, err => {
            this._logger.log('Error in MFA login. Could not retrieve credentials.', {error: err});
            this._sessionService.logout();
            this.mfaForm.setErrors({unauthorizedUser: true});
          }
        )
      } else {
        this.mfaForm.controls.totpCode.setErrors({invalidTotp: true});
        this._logger.log('Could not validate totp code', {error: resp});
      }
    }).catch(err => {
      this.mfaForm.controls.totpCode.setErrors({invalidTotp: true});
      this._logger.log('Error validating totp code', {error: err});
    });
  }

}
